import { render, staticRenderFns } from "./EditRecipientWhatsAppGroupItem.vue?vue&type=template&id=5832eb28"
import script from "./EditRecipientWhatsAppGroupItem.vue?vue&type=script&lang=js"
export * from "./EditRecipientWhatsAppGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports